import React, { Component, useEffect } from "react";
import Swiper, { Autoplay } from "swiper";
import "swiper/swiper.scss";
Swiper.use([Autoplay]);

const RoomCarousel = ({ roomphoto, roomtype }) => {
  useEffect(() => {
    // eslint-disable-next-line no-unused-vars

    const carousel = new Swiper(".clients-carousel", {
      slidesPerView: "auto",
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      speed: 5000,
      noSwiping: false,
      noSwipingClass: "swiper-slide",
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }, []);

  return (
    <>
      <div className="clients-carousel swiper-container relative before:absolute before:inset-0 before:z-10 before:pointer-events-none  after:absolute after:inset-0 after:left-auto  after:z-10 after:pointer-events-none overflow-hidden">
        <div className="swiper-wrapper !ease-linear select-none">
          {/* Carousel items */}

          {roomphoto[0] !== undefined &&
            roomphoto.map((current, i) => {
              //console.log(current);
              return (
                <div className=" swiper-slide bg-blue-600   rounded-xl flex items-center justify-center group overflow-hidden">
                  <img
                    className=" max-h-[720px]  transform duration-500 ease-in-out overflow-hidden"
                    src={roomphoto[i].photourl}
                    alt={`Listing${i}`}
                  />
                  <p className="absolute text-center  bg-blue-600  opacity-75 text-white text-2xl bottom-14 rounded-xl p-0.5 truncate ">
                    {`${roomphoto[i].photoname}`}
                  </p>
                  {/* <p className="absolute bg-black text-2xl bottom-2 right-2 rounded-xl p-0.5">
                      {`${current.StandardFields.ListPrice.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "USD",
                        }
                      )}`}
                    </p>  */}
                </div>
              );
            })}
          <div className="swiper-slide "></div>
        </div>
      </div>
    </>
  );
};

export default RoomCarousel;
